// Sequence-backed client id minters for the draft editor. Module-scoped
// counters guarantee monotonically-increasing ids within a session so the
// React reconciler's `key` props stay stable across re-renders. The ids
// are pre-save client placeholders; `applySaveResult` rewrites them to
// canonical server `it-NNNN` / UUID forms once a save lands.
//
// INVARIANT: counters are NEVER reset between drafts. Two drafts opened
// in the same session must not share an id even after the first one is
// closed. `closeDraft` zeros Zustand state but does not touch these
// module seqs.

let draftItemSeq = 0;
let draftPackageSeq = 0;
let draftBoxSeq = 0;
let draftBoxItemSeq = 0;

export function nextDraftItemId(): string {
  draftItemSeq += 1;
  return `draft-it-${draftItemSeq}`;
}

export function nextClientPackageId(): string {
  draftPackageSeq += 1;
  return `draft-pkg-${draftPackageSeq}`;
}

export function nextClientBoxId(): string {
  draftBoxSeq += 1;
  return `draft-bx-${draftBoxSeq}`;
}

export function nextClientBoxItemId(): string {
  draftBoxItemSeq += 1;
  return `draft-bxi-${draftBoxItemSeq}`;
}
